import "./Requests.scss";
import React, { } from "react";
import {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonList,
    IonItem,
    IonIcon,
    IonLabel,
} from "@ionic/react";
import { useTracked } from "../../state";
import LockButtonIcon from "../../components/LockButtonIcon";
import { chevronForward } from "ionicons/icons";
import { useHistory } from "react-router-dom";

interface Props {
    user: any;
}
const Requests: React.FC<Props> = React.memo(({ user }) => {
    const history = useHistory();

    return (
    <IonPage className="request-page">
        <IonHeader className="ion-no-border" mode="ios">
            <IonToolbar>
                <IonButtons slot="start">
                <IonMenuButton />
                </IonButtons>
                <IonTitle>Requests</IonTitle>
                <LockButtonIcon />
            </IonToolbar>
        </IonHeader>

    <IonContent>
        <div className="requests-container">
            <IonList mode="ios" lines="none">
                <IonItem 
                    lines="none" 
                    className="list-item-request"
                    button 
                    detail={false}
                    onClick={() => {
                        history.push(`/requests-sign-in`);
                    }}>
                    <IonIcon icon={chevronForward} slot="end" />
                    <IonLabel className="sc-IonLabel-ios-h sc-IonLabel-ios-s ios hydrated">
                        <h3>Sign In</h3>
                    </IonLabel>
                </IonItem>
            </IonList>
        </div>
    </IonContent>
    </IonPage>
    )

});

const MemoizedRequests = () => {
    const [state] = useTracked();
    const { user } = state;
    return <Requests user={user} />;
};

export default MemoizedRequests;